import type { Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/types";
import type { JSX } from "solid-js";

type Orientation = "horizontal" | "vertical";

const edgeToOrientationMap: Record<Edge, Orientation> = {
  top: "horizontal",
  bottom: "horizontal",
  left: "vertical",
  right: "vertical",
};

const orientationStyles: Record<Orientation, JSX.HTMLAttributes<HTMLElement>["class"]> = {
  horizontal: "h-(--line-thickness) left-0 right-0",
  vertical: "w-(--line-thickness) top-0 bottom-0",
};

const edgeStyles: Record<Edge, JSX.HTMLAttributes<HTMLElement>["class"]> = {
  top: "top-(--line-offset)",
  right: "right-(--line-offset)",
  bottom: "bottom-(--line-offset)",
  left: "left-(--line-offset)",
};

const strokeSize = 2;

const DropIndicator = (props: { edge: Edge; gap: number }) => (
  <div
    style={
      {
        "--line-thickness": `${strokeSize}px`,
        "--line-offset": `calc(-0.5 * (${props.gap}px + ${strokeSize}px))`,
      } as JSX.CSSProperties
    }
    class={`pointer-events-none absolute z-10 box-border bg-accent-blue ${orientationStyles[edgeToOrientationMap[props.edge]]} ${[edgeStyles[props.edge]]}`}
  />
);

export default DropIndicator;
